module.exports = __webpack_public_path__ + "img/icon_bsite.bf0fe62e.svg";